var _g, _circle, _circle2, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_518_2861)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 22.6785,
    cy: 18.9861,
    rx: 18.4363,
    ry: 18.4359,
    fill: "url(#paint0_radial_518_2861)"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.459,
    cy: 15.3605,
    r: 2,
    fill: "#39383D"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 29.2812,
    cy: 15.3605,
    r: 2,
    fill: "#39383D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.4714 28.8225C29.8186 28.7164 30.0168 28.3475 29.8802 28.0111C29.3681 26.7498 28.515 25.6506 27.4107 24.8401C26.1291 23.8995 24.5779 23.3983 22.9883 23.411C21.3986 23.4237 19.8556 23.9498 18.5893 24.9108C17.4981 25.7388 16.6627 26.8516 16.1709 28.1209C16.0397 28.4595 16.2438 28.8252 16.5927 28.9257C16.9416 29.0262 17.3026 28.823 17.4402 28.487C17.8492 27.4893 18.5188 26.6147 19.3841 25.9581C20.4247 25.1684 21.6926 24.7362 22.9988 24.7257C24.305 24.7152 25.5797 25.1271 26.6328 25.9C27.5085 26.5427 28.192 27.4064 28.6169 28.3975C28.7599 28.7312 29.1241 28.9286 29.4714 28.8225Z",
    fill: "#39383D"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_518_2861",
    x: 0.242188,
    y: 0.550232,
    width: 44.873,
    height: 44.8718,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_518_2861"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_518_2861",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_518_2861",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.7789 10.5056) rotate(77.6372) scale(27.5554 27.556)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB4BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5B73"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSad);
export default __webpack_public_path__ + "static/media/Sad.6af639dbb3969c58b2962a24eec45333.svg";
export { ForwardRef as ReactComponent };